import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'
import includes from 'lodash/includes'
import AttractionActions from '../../Redux/AttractionRedux'
import DestinationActions from '../../Redux/DestinationRedux'

class FormCreate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false,
      selectedItems: [],
      form: {
        attraction_id: [],
        places: [],
        destination_id: ''
      },
      page: 1,
      searchByQuery: '',
      searchByCity: '',
      searchByProvider: ''
    }
  }

  componentDidMount = () => {
    const data = {
      q: this.state.searchByQuery,
      c: this.state.searchByCity,
      page: this.state.page
    }
    if (this.props.type === 'attraction') {
      this.props.searchAttraction(data)
    } else {
      this.props.searchPlace(data)
    }
  }

  _toggleAttractionModal = () => {
    this.setState({ showModal: !this.state.showModal })
    if (this.state.showModal) {
      this.setState({ page: 1, searchByQuery: '', searchByCity: '', searchByProvider: '' })
      const data = {
        q: '',
        c: '',
        provider: '',
        page: 1
      }
      if (this.props.type === 'attraction') {
        this.props.searchAttraction(data)
      } else {
        this.props.searchPlace(data)
      }
    }
  }

  _inputChange = (event, field) => {
    const val = event.target.value
    field === 'q' && this.setState({ searchByQuery: val })
    field === 'c' && this.setState({ searchByCity: val })
    field === 'provider' && this.setState({ searchByProvider: val })
  }

  _search = (event) => {
    event.preventDefault()
    const data = {
      q: this.state.searchByQuery,
      c: this.state.searchByCity,
      provider: this.state.searchByProvider,
      page: 1
    }
    this.props.type === 'attraction'
      ? this.props.searchAttraction(data)
      : this.props.searchPlace(data)
  }

  _changePage = (page) => {
    this.setState({ page })
    const data = {
      q: this.state.searchByQuery,
      c: this.state.searchByCity,
      provider: this.state.searchByProvider,
      page
    }
    if (this.props.type === 'attraction') {
      this.props.searchAttraction(data)
    } else {
      this.props.searchPlace(data)
    }
  }

  _selectAttraction = (data) => {
    let attraction_id = [...this.state.form.attraction_id]
    let places = [...this.state.form.places]
    attraction_id.push(data.id)
    places.push({ id: data.id, type: data.place_type })
    let attraction = [...this.state.selectedItems]
    attraction.push(data)
    this.setState({
      selectedItems: attraction,
      form: {
        ...this.state.form,
        attraction_id,
        places
      }
    })
  }

  _removeAttraction = (id) => {
    let attraction_id = []
    let places = []
    let attraction = []
    this.state.selectedItems.forEach(data => {
      if (data.id !== id) {
        if (this.props.type === 'attraction') {
          attraction_id.push(data.id)
        } else {
          places.push({ id: data.id, type: data.place_type })
        }
        attraction.push(data)
      }
    })
    this.setState({
      selectedItems: attraction,
      form: {
        ...this.state.form,
        attraction_id,
        places
      }
    })
  }

  _save = (event) => {
    event.preventDefault()
    const data = this.state.form
    if (this.props.type === 'attraction') {
      this.props.saveAttraction(data)
    } else {
      this.props.savePlace(data)
    }
    this.props.closeModal()
  }

  render () {
    const { attraction, destination, type } = this.props
    const { destination_id } = this.state.form
    const { selectedItems } = this.state
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto' style={{ textTransform: 'capitalize' }}>
            Create { type } Destination Mapping
            {
              (attraction.fetching || attraction.processing) &&
              <div className='badge badge-info ml-2'>{attraction.fetching ? 'Loading' : 'Processing'} ...</div>
            }
          </h4>
        </div>
        <form onSubmit={(event) => this._save(event)}>
          <div className='form-group'>
            <label className='control-label'>Origin</label>
            <select className='form-control' name='destination_id' required value={this.state.form.destination_id} onChange={event => this.setState({ form: { ...this.state.form, destination_id: event.target.value } })}>
              <option value='' disabled>- Select Destination -</option>
              {
                destination.data && destination.data.map((item, i) => {
                  return (
                    <option key={i} value={item.id}>{item.name}</option>
                  )
                })
              }
            </select>
          </div>
          <div className='form-group'>
            <div className='d-flex justify-content-between' style={{ textTransform: 'capitalize' }}>
              <label className='control-label'>{ type }</label>
              <button type='button' className='btn btn-primary' onClick={() => this._toggleAttractionModal()}>Select List</button>
              <input type='hidden' name='attraction_id' value={this.state.form.attraction_id[0] || ''} />
            </div>
            <section>
              <div className='selected-list'>
                <table className='table table-hover table-striped'>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>City</th>
                      <th>Provider</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      !this.state.selectedItems || !this.state.selectedItems.length
                        ? <tr>
                          <td colSpan='4' className='text-center'>- No Data -</td>
                        </tr>
                        : this.state.selectedItems.map((item, i) => {
                          let city = '-'
                          if (item.place_type === 'landmark') {
                            if (item.city) {
                              city = item.city
                            }
                          } else {
                            if (item.city && item.city.name) {
                              city = item.city.name
                            }
                          }
                          return (
                            <tr key={i}>
                              <td>{ item.title }</td>
                              <td>{ city }</td>
                              <td>{ item.provider }</td>
                              <td>
                                <button type='button' onClick={() => this._removeAttraction(item.id)} className='btn btn-danger'>Remove</button>
                              </td>
                            </tr>
                          )
                        })
                    }
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <div className='form-group text-right'>
            <button type='button' className='btn btn-secondary' onClick={() => this.props.closeModal()}>Cancel</button>
            <button type='submit' disabled={!selectedItems.length || !destination_id} className='btn btn-primary ml-2'>Save</button>
          </div>
        </form>

        {/* MODAL SELECT ATTRACTION */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal} closeOnOverlayClick onClose={() => this._toggleAttractionModal()}>
          <section className='section' style={{ width: '80vw' }}>
            <div className='title-block mb-2'>
              <h4 className='title mr-auto' style={{ textTransform: 'capitalize' }}>
                Select { type }
                {(attraction.fetching || attraction.processing) &&
                  <div className='badge badge-info ml-2'>{attraction.fetching ? 'Loading' : 'Processing'} ...</div>
                }
              </h4>
            </div>
            <div className='row'>
              <section className='col-xs-12 col-sm-6'>
                <h5>Selected</h5>
                <div className='selected-list'>
                  <table className='table table-hover table-striped'>
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>City</th>
                        <th>Provider</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        !this.state.selectedItems || !this.state.selectedItems.length
                          ? <tr>
                            <td colSpan='4' className='text-center'>- No Data -</td>
                          </tr>
                          : this.state.selectedItems.map((item, i) => {
                            let city = '-'
                            if (item.place_type === 'landmark') {
                              if (item.city) {
                                city = item.city
                              }
                            } else {
                              if (item.city && item.city.name) {
                                city = item.city.name
                              }
                            }
                            return (
                              <tr key={i}>
                                <td>{ item.title }</td>
                                <td>{ city }</td>
                                <td>{ item.provider }</td>
                                <td>
                                  <button type='button' onClick={() => this._removeAttraction(item.id)} className='btn btn-danger'>Remove</button>
                                </td>
                              </tr>
                            )
                          })
                      }
                    </tbody>
                  </table>
                </div>
                <div className='text-right mt-2'>
                  <button type='button' className='btn btn-primary btn-lg' onClick={() => this._toggleAttractionModal()}>OK</button>
                </div>
              </section>
              <section className='col-xs-12 col-sm-6'>
                <h5 style={{ textTransform: 'capitalize' }}>{type} List</h5>
                <form className='row mb-2' onSubmit={(event) => this._search(event)}>
                  <div className='col-10'>
                    <input type='search' name='search' className='form-control' placeholder='Search by Title' onChange={(event) => this._inputChange(event, 'q')} />
                  </div>
                  <div className='col-2'>
                    <button className='btn btn-primary'>
                      <i className='fa fa-search' />
                    </button>
                  </div>
                </form>
                <form className='row mb-2' onSubmit={(event) => this._search(event)}>
                  <div className='col-10'>
                    <input type='search' name='search' className='form-control' placeholder='Search by City' onChange={(event) => this._inputChange(event, 'c')} />
                  </div>
                  <div className='col-2'>
                    <button className='btn btn-primary'>
                      <i className='fa fa-search' />
                    </button>
                  </div>
                </form>
                <form className='row mb-2' onSubmit={(event) => this._search(event)}>
                  <div className='col-10'>
                    <select name='provider' className='form-control' placeholder='Search by Provider' onChange={(event) => this._inputChange(event, 'provider')}>
                      <option value=''>ALL</option>
                      <option value='BMG'>BMG</option>
                      <option value='KLOOK'>KLOOK</option>
                    </select>
                  </div>
                  <div className='col-2'>
                    <button className='btn btn-primary'>
                      <i className='fa fa-search' />
                    </button>
                  </div>
                </form>
                <table className='table table-hover table-striped'>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>City</th>
                      <th>Provider</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      // !attraction.data.data || !attraction.data.data.length
                      !attraction.dataSearch.data || !attraction.dataSearch.data.length
                        ? <tr>
                          <td colSpan='4' className='text-center'>- No Data -</td>
                        </tr>
                        // : attraction.data.data.map((item, i) => {
                        : attraction.dataSearch.data.map((item, i) => {
                          let city = '-'
                          if (item.place_type === 'landmark') {
                            if (item.city) {
                              city = item.city
                            }
                          } else {
                            if (item.city && item.city.name) {
                              city = item.city.name
                            }
                          }
                          return (
                            <tr key={i}>
                              <td>{type === 'place' && <strong>[ {item.place_type} ]</strong> } { item.title }</td>
                              <td>{ String(city) }</td>
                              <td>{ item.provider || '-' }</td>
                              <td>
                                {!includes(this.state.form.attraction_id, item.id) &&
                                <button type='button' onClick={() => this._selectAttraction(item)} className='btn btn-info'>Select</button>
                                }
                              </td>
                            </tr>
                          )
                        })
                    }
                  </tbody>
                </table>
                <section className='text-center'>
                  {
                    // attraction.data.total &&
                    attraction.dataSearch.total &&
                    <Pagination
                      innerClass='pagination'
                      itemClass='page-item'
                      linkClass='page-link'
                      // activePage={attraction.data.page || this.state.page}
                      activePage={attraction.dataSearch.page || this.state.page}
                      itemsCountPerPage={10}
                      // totalItemsCount={attraction.data.total}
                      totalItemsCount={attraction.dataSearch.total}
                      pageRangeDisplayed={5}
                      onChange={this._changePage}
                    />
                  }
                </section>
              </section>
            </div>
          </section>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction,
  destination: state.destination
})

const dispatchToProps = (dispatch) => ({
  searchAttraction: (data) => dispatch(AttractionActions.attractionSearchRequest(data)),
  saveAttraction: (data) => dispatch(DestinationActions.addAttractionToDestinationRequest(data)),
  searchPlace: (data) => dispatch(AttractionActions.placeSearchRequest(data)),
  savePlace: (data) => dispatch(DestinationActions.addPlaceToDestinationRequest(data))
})

export default connect(stateToProps, dispatchToProps)(FormCreate)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/AttractionCreateMapping.js